$(document).on('ready', () => {
  if ($('#calendar-index').length !== 0) {
    $('#start_date').on('dp.hide', e => {
      $('#end_date').data('DateTimePicker').date(e.date)
      $('#end_date').data('DateTimePicker').minDate(e.date)
    })
  }
})
